import React from "react";

const MailDeliveryIcon = ({ className = "w-5 h-5", ...props }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      {/* Post box base */}
      <rect
        x="3"
        y="8"
        width="18"
        height="12"
        rx="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      {/* Post box door */}
      <rect
        x="4"
        y="10"
        width="16"
        height="8"
        rx="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      {/* Mail slot */}
      <rect
        x="10"
        y="6"
        width="4"
        height="2"
        rx="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      {/* Flag */}
      <path
        d="M12 2v4l2-2h-4l2 2z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      {/* Mail inside */}
      <rect
        x="6"
        y="12"
        width="8"
        height="4"
        rx="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default MailDeliveryIcon;
